import React from "react";
import styled from "styled-components";
import { logoutUser } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const LogoutButtonStyled = styled.button`
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 1rem;

  &:hover {
    background-color: var(--primary-color-dark);
  }

  &:disabled {
    background-color: var(--gray-color);
    cursor: not-allowed;
  }
`;

const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      await logoutUser();
      // Actualizar el estado de autenticación
      logout();
      // Navegar a la página de login sin forzar recarga
      navigate("/login");
    } catch (error) {
      console.error("Error al hacer logout:", error);
      // En caso de error, asegurar que el estado de autenticación se actualice
      logout();
      navigate("/login");
    }
  };

  return (
    <LogoutButtonStyled onClick={handleLogout}>
      Cerrar sesión
    </LogoutButtonStyled>
  );
};

export default LogoutButton;
